import React, {useState, useEffect, useRef} from 'react';
import './ActionItemCard.css';
import './Card.css';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function ActionItemCard({show_display}) 
{
    const {app_user, action_item, action_item_display_refresh, action_item_reactions, 
           setMainColumnDisplayType, num_display_columns, setSelectedActionItem, setActionItemDisplayRefresh} = useCTAL();
           
    const [img_loc] = useState('./images/'); 
    const [img_ext] = useState('.svg'); 
    const [img_sel] = useState('-sel'); 

    const [img_edit_action] = useState('form'); 
    const [img_file]        = useState('file'); 
    const [img_comments]    = useState('comments'); 
    const [img_history]     = useState('history'); 
    const [img_info]        = useState('info'); 
    
    const [img_edit_action_file, setImgEditActionFile] = useState(img_loc + img_edit_action + img_sel + img_ext); 
    const [img_file_file,        setFileFile]          = useState(img_loc + img_file        + img_ext); 
    const [img_comments_file,    setCommentsFile]      = useState(img_loc + img_comments    + img_ext); 
    const [img_history_file,     setHistoryFile]       = useState(img_loc + img_history     + img_ext); 
    const [img_info_file,        setInfoFile]          = useState(img_loc + img_info        + img_ext); 

    const [current_display_type, setCurrentDisplayType] = useState("action-item-form"); 
       
    const [like, setLike] = useState(false);
    const [dislike, setDisLike] = useState(false);
    const [like_icon, setLikeIcon] = useState("./images/like.svg");
    const [dislike_icon, setDisLikeIcon] = useState("./images/dislike.svg");

    const tooltipRef_edit     = useRef(null);
    const tooltipRef_files    = useRef(null);
    const tooltipRef_comments = useRef(null);
    const tooltipRef_history  = useRef(null);
    const tooltipRef_info     = useRef(null);

    useEffect(() => {
        const tooltip_edit     = new window.bootstrap.Tooltip(tooltipRef_edit.current, { container: 'body', trigger: 'hover' });
        const tooltip_files    = new window.bootstrap.Tooltip(tooltipRef_files.current, { container: 'body', trigger: 'hover' });
        const tooltip_comments = new window.bootstrap.Tooltip(tooltipRef_comments.current, { container: 'body', trigger: 'hover' });
        const tooltip_history  = new window.bootstrap.Tooltip(tooltipRef_history.current, { container: 'body', trigger: 'hover' });
        const tooltip_info     = new window.bootstrap.Tooltip(tooltipRef_info.current, { container: 'body', trigger: 'hover' });
  
        return () => {
            tooltip_edit.dispose();
            tooltip_files.dispose();
            tooltip_comments.dispose();
            tooltip_history.dispose();
            tooltip_info.dispose();
        };
    }, []);

    const change_display = (display_type) => {
        if (display_type == current_display_type) return; //No Change

        setImgEditActionFile(img_loc + img_edit_action + img_ext);
        setFileFile(img_loc          + img_file        + img_ext);
        setCommentsFile(img_loc      + img_comments    + img_ext);
        setHistoryFile(img_loc       + img_history     + img_ext);
        setInfoFile(img_loc          + img_info        + img_ext);

        switch (display_type)
        {
            case "action-item-form": setImgEditActionFile(img_loc + img_edit_action + img_sel + img_ext); break;
            case "action-item-files":         setFileFile(img_loc + img_file        + img_sel + img_ext); break;
            case "action-item-comments":  setCommentsFile(img_loc + img_comments    + img_sel + img_ext); break;
            case "action-item-history":    setHistoryFile(img_loc + img_history     + img_sel + img_ext); break;
            case "action-item-information":   setInfoFile(img_loc + img_info        + img_sel + img_ext); break;
        }
        setCurrentDisplayType(display_type);
        show_display(display_type);
    } 

    var likes_label    = (action_item.NumLikes == 1 ? "like" : "likes");
    var dislikes_label = (action_item.NumDisLikes == 1 ? "dislike" : "dislikes");
    
    var file_txt     = (action_item.NumAttachedFiles == 1 ? `${action_item.NumAttachedFiles} file` : `${action_item.NumAttachedFiles} files`);
    var comment_txt  = (action_item.NumComments == 1 ? `, ${action_item.NumComments} comment` : `, ${action_item.NumComments} comments`);

    var files_style_class = (action_item.NumAttachedFiles > 0 ? "card-link-highlight" : "card-link-normal");
    var comment_style_class = (action_item.NumComments > 0 ? "card-link-highlight" : "card-link-normal");
    
    useEffect(() =>
    {
        set_reaction_icons();
    }, [ action_item ]);

    useEffect(() =>
    {
        if (like) {
            setLikeIcon("./images/like-sel.jpg");
            setDisLikeIcon("./images/dislike.svg");
        }
        else if (dislike) {
            setLikeIcon("./images/like.svg");
            setDisLikeIcon("./images/dislike-sel.jpg");
        }
        else { //both are false
            setLikeIcon("./images/like.svg");
            setDisLikeIcon("./images/dislike.svg");
        }
    }, [ like, dislike ]);

    var action_summary_max_len = 50;
    if (num_display_columns == 1) //Mobile
        action_summary_max_len = 37;

    var action_summary = action_item.Summary;
    if (action_item.Summary.length > action_summary_max_len)
        action_summary = action_item.Summary.substring(0,action_summary_max_len) + "...";

    var CreatedDT = new Date(action_item.CreatedAt);
    const action_create_date = CreatedDT.toLocaleString("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric",
    });

    const set_reaction_icons = () => { 
        for (var i=0; i < action_item_reactions.length; i++) {
            if (action_item_reactions[i].UserName == app_user.UserName) {
                if (action_item_reactions[i].ReactionType == "Like") {
                    setLike(true);
                    setDisLike(false);
                }
                else if (action_item_reactions[i].ReactionType == "DisLike") {
                    setLike(false);
                    setDisLike(true);
                }

                if (DEBUG) console.log(`ActionItemCard - FOUND Reaction: ${action_item_reactions[i].ReactionType}`);
                return;
            }
        }

        if (DEBUG) console.log(`ActionItemCard - Reaction NOT FOUND for ${action_item.Name}`);
        setLike(false);
        setDisLike(false);
    }

    const refresh_action_item = () => { 
        setSelectedActionItem(action_item); //Keep this Action Item Detail Displayed
        setActionItemDisplayRefresh(true);  //Trigger the Action-Item bulk download in ActionItem.mjs
    }
    
    //This breaks design of only updating UI on DB result round-trip, but Eric and Bill both complained 
    const update_local_reaction = (reaction_type) => { 
        switch (reaction_type)
        {
            case "Like":
                setLike(!like);
                if (dislike) setDisLike(false);
                break;
            case "DisLike":
                setDisLike(!dislike);
                if (like) setLike (false);
                break;
        }
    }

    const create_reaction = (reaction_type) => { 
        if (DEBUG) console.log(`ActionItemCard - Received Reaction: ${reaction_type}`);

        update_local_reaction(reaction_type);  //This breaks design of only updating UI on DB result round-trip, but Eric and Bill both complained 

        var type = "create_reaction";
        var target_type     = action_item.Type;
        var target_pk       = action_item.PK;
        var target_sk       = action_item.SK;
        var user_name       = app_user.UserName;
        var user_full_name  = app_user.UserFullName;

        var body = JSON.stringify({type, reaction_type, target_type, target_pk, target_sk, user_name, user_full_name});
        
        console.log(`ActionItemCard - Creating new Action-Item Reaction (${reaction_type}) via ctal-set for: ${action_item.Name}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-set`, { method: "POST", body: body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: body })
            .then(response => response.json())
            .then(() => refresh_action_item());
            //.catch(setError);
    }

    var team_link_icon;
    if (num_display_columns < 2)
        team_link_icon = <a class="me-3" href="#"><img class="card-icon" src="./checklist.svg" alt="team-display" border="0" onClick={ () => setMainColumnDisplayType("Team") }/></a>;
    else
        team_link_icon = <></>;

    return (
        <>
            <div class="card text-center">
                <div id="action-item-card-body" class="card-body">
                    <h5 class="card-title py-0">Action: {action_item.Name}</h5>
                    <h6 class="card-subtitle mb-2 text-body-secondary">{action_summary}</h6>
                    <h6 id="action-create-date" class="card-subtitle mb-2"><small>Created By {action_item.CreatedBy} on {action_create_date}</small></h6>
                    <div class="row">
                        <div class="col-1"></div>
                        <div class="col-5 text-center">
                            <small>
                                {action_item.NumLikes} {likes_label}, {action_item.NumDisLikes} {dislikes_label}
                            </small>
                        </div>
                        <div class="col-6 text-end">
                            <small>
                                <span class={files_style_class}><a href="#" onClick={ () => change_display("action-item-files") }>{file_txt}</a></span>
                                <span class={comment_style_class}><a href="#" onClick={ () => change_display("action-item-comments") }>{comment_txt}</a></span>
                            </small>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-body-secondary">
                    <div class="row">
                        <div class="col-1">{team_link_icon}</div>

                        <div class="col-5 text-center">                      
                            <a href="#"><img class="card-icon" src={like_icon}    alt="like"    border="0" onClick={ () => create_reaction("Like") }/></a> 
                            <a href="#"><img class="card-icon" src={dislike_icon} alt="dislike" border="0" onClick={ () => create_reaction("DisLike") }/></a> 
                        </div>

                        <div class="col-6 text-end">
                            <a href="#" ref={tooltipRef_edit}     data-bs-toggle="tooltip" data-bs-title="Edit Action"        data-bs-delay="750"><img class="card-icon"     src={img_edit_action_file} alt="form"     border="0" onClick={ () => change_display("action-item-form") }/></a>
                            <a href="#" ref={tooltipRef_files}    data-bs-toggle="tooltip" data-bs-title="Attach Files"       data-bs-delay="750"><img class="card-icon"     src={img_file_file}        alt="file"     border="0" onClick={ () => change_display("action-item-files") }/></a>                     
                            <a href="#" ref={tooltipRef_comments} data-bs-toggle="tooltip" data-bs-title="Add Comments"       data-bs-delay="750"><img class="card-icon"     src={img_comments_file}    alt="comments" border="0" onClick={ () => change_display("action-item-comments") }/></a>
                            <a href="#" ref={tooltipRef_history}  data-bs-toggle="tooltip" data-bs-title="Action History"     data-bs-delay="750"><img class="card-icon"     src={img_history_file}     alt="history"  border="0" onClick={ () => change_display("action-item-history") }/></a>
                            <a href="#" ref={tooltipRef_info}     data-bs-toggle="tooltip" data-bs-title="Action Information" data-bs-delay="750"><img class="card-icon-end" src={img_info_file}        alt="info"     border="0" onClick={ () => change_display("action-item-information") }/></a>
                        </div>
                    </div>  
                </div>
            </div>
        </>
    );
}